import pageApi from '../../api/page.api.js'

const state = {
	enterpriseType: []
}

const getters = {
	getPubPage: (state, getters, rootState) => data => {
		let infos = ''
		if (data.company) infos += `&company=${data.company}`
		if (data.product) infos += `&product=${data.product}`
		return rootState.globals.baseUrl + '/page/pubpageWeb?pageId=' + data.pageId + '&webType=' + data.webType + infos
	},
	formatImgUrl: (state, getters, rootState) => url => {
		return /^https?:\/\//i.test(url) ? url : rootState.globals.basImagePath + url
	}
}

const mutations = {
	setSiteListState (state, data) {
		for (let key in data) {
			if (data.hasOwnProperty(key)) {
				state[key] = data[key]
			}
		}
	},
	SET_ENTERPRISE_TYPE (state, data) {
		state.enterpriseType = data
	}
}

const actions = {
	getPubList (context, data) {
		return pageApi.publist(data).then(res => {
			return res.data
		})
	},
	getPubList2 (context, data) {
		return pageApi.publist2(data).then(res => {
			return res.data
		})
	},
	getProjList (context, data) {
		return pageApi.projlist(data).then(res => {
			return res.data
		})
	},
	getProjHtml (context, data) {
		return pageApi.projhtml(data).then(res => {
			return res.data
		})
	},
	postCreateProject (context, data) {
		return pageApi.createProject(data).then(res => {
			return res
		})
	},
	createProjectLdy (context, data) {
		return pageApi.createProjectLdy(data).then(res => {
			return res
		})
	},
	userpageLdy (context, data) {
		return pageApi.userpageLdy(data).then(res => {
			return res
		})
	},
	putCopy (context, data) {
		return pageApi.copy(data).then(res => {
			return res.data
		})
	},

	updProjectStatus (context, data) {
		return pageApi.updProjectStatus(data)
	},
	shiftDelete (context, data) {
		return pageApi.shiftDelete(data)
	},
	imgCount (context, data) {
		return pageApi.imgCount(data)
	},
	// 存储只需一次请求数据
	async getEntpriseType ({ commit, state }) {
		// 页面类型
		const typeData = await pageApi.enterpriseType()
		const enterpriseType = typeData.data.data.map(value => {
			value.code = value.typeName
			value.name = value.typeName
			value.act = false
			return value
		})
		commit('SET_ENTERPRISE_TYPE', enterpriseType)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
